import React from "react";
import { FiCpu, FiLayers, FiZap, FiSettings } from "react-icons/fi";

const features = [
    {
        icon: <FiCpu className="h-6 w-6 text-gray-700" />,
        title: "AI generatsiya",
        text: "Ilg'or algoritmlar kontentingizni tahlil qiladi va tegishli savollar yaratadi",
    },
    {
        icon: <FiLayers className="h-6 w-6 text-gray-700" />,
        title: "Ko'p formatlar",
        text: "Hujjatlar, fayllar va matnli materiallarni qo'llab-quvvatlash",
    },
    {
        icon: <FiZap className="h-6 w-6 text-gray-700" />,
        title: "Tezkor natijalar",
        text: "Soatlar emas, balki bir necha daqiqada tayyor testlarni oling",
    },
    {
        icon: <FiSettings className="h-6 w-6 text-gray-700" />,
        title: "Moslashtirilgan testlar",
        text: "Ehtiyojlaringiz uchun savollar soni, turi va murakkabligini tanlang",
    },
];

export default function FeaturesSection() {
    return (
        <section
            id="features"
            className="bg-[#ffffff] py-16 sm:py-20 md:py-10"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6">
                {/* Sarlavha */}
                <div className="text-center">
                    <h2 className="text-[30px] sm:text-[36px] md:text-[40px] font-bold tracking-tight text-gray-900">
                        Sun&apos;iy intellektning kuchli
                        <br className="hidden sm:block" />
                        <span className="block">imkoniyatlari</span>
                    </h2>
                    <p className="mt-4 text-sm sm:text-base text-gray-500">
                        Har qanday kontentdan sifatli testlarni avtomatik yaratish
                    </p>
                </div>

                {/* Kartalar */}
                <div className="mt-12 grid gap-8 md:gap-12 md:grid-cols-2">
                    {features.map((item) => (
                        <div
                            className="group cursor-pointer
    relative flex flex-col gap-4 rounded-3xl border border-gray-200 
   px-6 py-10 shadow-sm 
    transition-all duration-300 ease-out
    hover:shadow-lg hover:border-gray-300
  "
                        >
                            {/* gradient hover layer */}
                            <div
                                className="
      absolute inset-0 rounded-3xl opacity-0 group-hover:opacity-100 
      transition-opacity duration-300 
      bg-gradient-to-br from-white via-white to-[#f5f5f5]
    "
                            />

                            {/* CONTENT (gradient bilan qoplanib ketmasligi uchun relative) */}
                            <div className="relative z-10  column items-start gap-4">
                                <div className="h-12 w-12 rounded-2xl bg-[#f4f4f4] flex items-center justify-center">
                                    {item.icon}
                                </div>

                                <div>
                                    <h3 className="text-lg font-semibold text-gray-900">{item.title}</h3>
                                    <p className="mt-2 text-sm text-gray-500">{item.text}</p>
                                </div>
                            </div>
                        </div>

                    ))}
                </div>

                {/* Pastdagi pill */}
                <div className="mt-10 flex justify-center">
                    <div className="inline-flex items-center gap-2 rounded-full bg-gray-100 px-4 py-2 text-xs sm:text-sm text-gray-600">
                        <span className="h-2 w-2 rounded-full bg-gray-500" />
                        <span>Sun&apos;iy intellektning kuchli imkoniyatlari yordamida yaratilgan</span>
                    </div>
                </div>
            </div>
        </section>
    );
}
